import { apiClient } from './client.js';

export const supportChatApi = {
  /** Trợ lý AI đang bật hay tắt: { aiEnabled, provider } */
  getStatus: () => apiClient.get('/support-chat/status'),

  /** Mở khung chat: { visitorId, aiEnabled, retentionDays, conversation: {mode, agentName, humanRequested}, messages } */
  openConversation: (visitorId) => apiClient.get('/support-chat/conversation', { params: { visitorId: visitorId || undefined } }),

  /** Tin mới sau afterId và trạng thái tư vấn viên: { visitorId, conversation, messages } */
  getUpdates: (visitorId, afterId) => apiClient.get('/support-chat/conversation/updates', { params: { visitorId, afterId } }),

  /**
   * Câu khách gõ: { visitorId, conversation, messages, fallback }. fallback = true: tự trả lời bằng BOT từ khóa rồi gọi log
   * @param {{visitorId: string, text: string, useAi: boolean, pagePath: string}} payload
   */
  sendMessage: (payload) => apiClient.post('/support-chat/message', payload, { timeout: 25000 }),

  /** Lưu câu trả lời của BOT từ khóa: entries [{sender: 'USER'|'BOT', text, actions}] */
  logExchange: (payload) => apiClient.post('/support-chat/log', payload),

  /** Khách yêu cầu gặp tư vấn viên */
  requestHuman: (payload) => apiClient.post('/support-chat/request-human', payload),

  // ----- Trang quản trị (ADMIN) -----
  adminListConversations: (params) => apiClient.get('/support-chat/admin/conversations', { params }),
  adminGetMessages: (id, afterId = 0) => apiClient.get(`/support-chat/admin/conversations/${id}/messages`, { params: { afterId } }),
  adminTakeover: (id) => apiClient.post(`/support-chat/admin/conversations/${id}/takeover`),
  adminRelease: (id) => apiClient.post(`/support-chat/admin/conversations/${id}/release`),
  adminSendMessage: (id, text) => apiClient.post(`/support-chat/admin/conversations/${id}/messages`, { text }),
};
